import { useRef } from "react";

export const useDragHaptics = (delay = 500) => {
  const timeoutRef = useRef<number | null>(null);

  const onPressStart = () => {
    timeoutRef.current = window.setTimeout(() => {
      if (navigator.vibrate) {
        navigator.vibrate(10);
      }
    }, delay);
  };

  const onPressEnd = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
  };

  return {
    onPressStart,
    onPressEnd
  };
};
